











































































import Vue from 'vue';

import { AuthenticationMethod } from '@/authentication';
import SolidAuth from '@/authentication/SolidAuth';

import LoginPrevious from '@/components/LoginPrevious.vue';
import LoginSolid from '@/components/LoginSolid.vue';

interface Data {
    loginUrl: string | null;
    previousLoginUrl: string | undefined;
}

export default Vue.extend({
    components: {
        LoginPrevious,
        LoginSolid,
    },
    data: (): Data => ({
        loginUrl: null,
        previousLoginUrl: undefined,
    }),
    created() {
        this.previousLoginUrl = SolidAuth.previousLogin?.loginUrl;
    },
    methods: {
        loginWithSolid() {
            this.loginUrl = 'https://';
        },
        loginOffline() {
            this.$auth.loginOffline();
        },
        async loginWithPreviousLogin() {
            const previousLogin = SolidAuth.previousLogin;

            if (!previousLogin)
                return;

            try {
                await this.$auth.loginWithSolid(previousLogin.loginUrl, previousLogin.authenticationMethod);
            } catch (error) {
                this.$ui.showError(error);
            }
        },
        async submitLoginWithSolid(authenticationMethod?: AuthenticationMethod) {
            if (!this.loginUrl)
                return;

            try {
                await this.replaceLegacyDomains();
                await this.$auth.loginWithSolid(this.loginUrl, authenticationMethod);
            } catch (error) {
                this.$ui.showError(error);
            }
        },
        async forgetPreviousLogin() {
            if (!this.previousLoginUrl)
                return;

            await SolidAuth.logout();

            this.previousLoginUrl = undefined;
        },
        async replaceLegacyDomains() {
            if (!this.isUsingLegacySolidCommunity())
                return;

            const replaceDomain = await this.replaceLegacySolidCommunity();
            if (!replaceDomain)
                return;

            this.loginUrl = this.loginUrl!.replace('solid.community', 'solidcommunity.net');
        },
        isUsingLegacySolidCommunity(): boolean {
            return this.loginUrl!.includes('solid.community');
        },
        replaceLegacySolidCommunity(): Promise<boolean> {
            return this.$ui.confirm(
                [
                    'The `solid.community` domain has been moved to `solidcommunity.net`, ' +
                    'do you want to use that instead?\n',
                    '[learn more](https://gitlab.com/solid.community/proposals/-/issues/16)',
                ].join('\n'),
                { markdown: true },
            );
        },
    },
});
